import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import type { History } from 'history';
import NewHelpCenterView from '../Advisor/Tools/NewHelpCenter/NewHelpCenter';
import HotTopicSeeMoreCategory from '../Advisor/Tools/hotTopic/HotTopicSeeMoreCategory';
import HotTopicItemDialog from '../Advisor/Tools/hotTopic/HotTopicItemDialog/HotTopicItemDialog';

interface SigningClassroomIframeRouterProps {
  history: History;
  userDetails?: unknown;
}

/** Classroom iframe only: list routes plus the video dialog. Other app routes stay behind auth. */
const SigningClassroomIframeRouter: React.FC<SigningClassroomIframeRouterProps> = ({ history, userDetails }) => (
  <Router history={history}>
    <React.Fragment>
      <HotTopicItemDialog />
      <Switch>
        <Route
          path="/new_help_center_category"
          component={HotTopicSeeMoreCategory}
          userDetails={userDetails}
          userType="Adviser"
        />
        <Route
          path="/new_help_center_tag"
          component={HotTopicSeeMoreCategory}
          userDetails={userDetails}
          userType="Adviser"
        />
        <Route path="/new_help_center" component={NewHelpCenterView} userDetails={userDetails} />
      </Switch>
    </React.Fragment>
  </Router>
);

export default SigningClassroomIframeRouter;
